export default __webpack_public_path__ + "static/media/screen1.b67dad35.webp";